module.exports = __webpack_public_path__ + "static/people_img30-7fe8fe6ab1068e955bfa30260535c82e.png";